// extracted by mini-css-extract-plugin
export default {"discussion-item":"discussion-item__1Efim","tag":"tag__2GOtL","title":"title__2Lxgq","last-action":"last-action__1qs5c","reply-number":"reply-number__3Fnca"};